// extracted by mini-css-extract-plugin
export default {"fruitStyle":"FruitCard_fruitStyle__Er-7Q","fruitBox":"FruitCard_fruitBox__fF1Gb"};